export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'PRIVATE_LAND_ADD_MARKERS':
      return payload
    case 'PRIVATE_LAND_REMOVE_MARKERS':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
